import React, { Component } from "react";

import { setDepthOfPit } from "util/aws-manager";
import Button from "material-ui/Button";
import {
  getDeviceCatalogue
} from "util/aws-manager";
import {
  CardText,
} from "reactstrap";
import FilterModal from './../filterModal/filterModal';
import SearchBox from "components/SearchBox";
import { searchDevices } from "util/aws-manager";
import { highlightNavigatedMenu } from "util/highlightSidebarOption";
import moment from "moment";
import { connect } from "react-redux";
import { filterRecords, filterDeviceCatalogueData } from './../filterModal/filterFunction';
import _ from "lodash";
import EnhancedTable from './EnhancedTable';

class DeviceCatalogue extends Component {
  currentPath;
  constructor(props) {
    super(props);
    this.state = {
      // nodeVitalsData: []
      filterData: [],
    };
  }
  componentDidMount() {
    getDeviceCatalogue(this.props.deviceId)
      .then((data) => {
        if (this.props.deviceCatalogueFilters.length > 0) {
          this.props.updateDeviceCatalogueData({ data, pageNumber: this.props.deviceCatalogue.pageNumber });
          // let items = filterDeviceCatalogueData(data);
          let filterData = filterRecords(data, this.props.deviceCatalogueFilters);
          this.props.updateDeviceCatalogueFilterData({ data: filterData, pageNumber: this.props.deviceCatalogue.pageNumber });
          this.props.addDeviceCatalogueFilter([]);
        }
        else {
          this.props.updateDeviceCatalogueData({ data, pageNumber: this.props.deviceCatalogue.pageNumber });
          this.props.updateDeviceCatalogueFilterData({ data, pageNumber: this.props.deviceCatalogue.pageNumber });
        }
      })
      .catch((error) => {
        console.log('error: ', error);
      })
    this.currentPath = this.props.location.pathname;
  }

  componentWillMount() {
    this.unlisten = this.props.history.listen((location) => {
      this.currentPath = location.pathname;
    });
  }

  componentWillUnmount() {
    this.unlisten();
  }

  render() {
    return (
      <div className="row configuration-page">
        <div className="col-12">
          <div className="jr-card d-sm-flex justify-content-sm-between align-items-sm-center">
            <div className="col-12 col-sm-6 col-lg-10">
              <h1 className="mb-0">Device Catalogue</h1>
            </div>
            <div className="col-12 col-sm-6 col-lg-2">
              {/* Device ID: {this.props.deviceId} */}
            </div>
          </div>
        </div>
        <div className="col-12">
          <FilterModal
            filter={this.props.deviceCatalogueFilters}
            data={this.state.filterData}
            setFilteredData={(data) => {
              this.props.updateDeviceCatalogueFilterData({ data, pageNumber: 0 });
            }} />
          <div className="row">
            <EnhancedTable
              passDataForFilter={(item) => {
                this.setState({
                  filterData: item,
                })
              }}
              updateDeviceId={(deviceId) => {
                this.props.updateDeviceId(deviceId);
                if (
                  !(
                    this.currentPath === "/app/components/heartbeat" ||
                    this.currentPath === "/app/components/notifications"
                  )
                ) {
                  highlightNavigatedMenu("heartbeat", `#${this.currentPath}`);
                  this.props.history.push("/app/components/heartbeat");
                }
              }} />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ symbioticReducer }) => {
  return {
    deviceId: symbioticReducer.deviceId,
    deviceCatalogue: symbioticReducer.deviceCatalogue,
    deviceCatalogueFilters: symbioticReducer.deviceCatalogueFilters
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateDeviceId: (id) => {
      dispatch({ type: "UPDATE_DEVICE_ID", deviceId: id });
    },
    updateDeviceCatalogueData: (data) => {
      dispatch({ type: "DEVICE_CATELOGUE_DATA", deviceCatalogue: data });
    },
    addDeviceCatalogueFilter: (data) => {
      dispatch({
        type: 'DEVICE_CATALOGUE_FILTER',
        deviceCatalogueFilters: data
      });
    },

    updateDeviceCatalogueFilterData: (data) => {
      dispatch({ type: "DEVICE_CATELOGUE_FILTER_DATA", deviceCatalogueFilter: data });
    },
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(DeviceCatalogue);



// WEBPACK FOOTER //
// ./app/routes/deviceCatalogue/index.js